import api from "../../services/api";
import { logout } from "./user.middleware";
import { setUser } from "../slices/user.slice";
import { initLoading, endLoading, setError, setLevels } from "../slices/generics.slice";
import {
  setGrades,
  setPlans,
  setClassRoom,
  setDemoClass,
  setLastSchedulesStudent,
  setAllNextClassesStudent,
  setStudentDashboardHeader,
  setAllPreviousClassesStudent,
} from "../slices/student.slice";

export const getStudentPlansUser = (id) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/studentplans/get/activeplans?userId=${id}`);
      const resp = response?.data?.result?.items;

      await dispatch(setPlans(resp));
      await dispatch(setGrades(resp[0]?.student?.studentLevelGrades));

      return resp;
    } catch (error) {
      console.log("getStudentPlansUser", error);
      dispatch(setError(error.message));
    }
  };
};

export const getClassRoom = (id) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/studentManagement/getbyuser/${id}`);
      const res = response.data.result.items[0].students[0]?.classToolId;

      const result = sessionStorage.getItem("@dataUser");
      const dataUser = JSON.parse(result);

      res?.includes("http://") || res?.includes("https://")
        ? dispatch(setClassRoom(res))
        : dispatch(setClassRoom(`Skype: ${res}`));

      await dispatch(setUser({ ...dataUser, picture: response.data.result.items[0].picture }));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getRatingLength", error);
      dispatch(setError(error.message));
    }
  };
};

export const putRatingStudent = (data, action) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const url = `/ratings/${action}TeacherRating`;
    try {
      if (action === "update") {
        const response = await api.put(url, data);
        const resp = response.data;
        return resp;
      } else {
        const response = await api.post(url, data);
        const resp = response.data;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putRatingStudent", error.response.data);

      dispatch(setError(error.response.data.message));
      dispatch(endLoading());
      return true;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTeacherRestriction = (data, bodyBlockTeacher, action) => {
  return async (dispatch) => {
    dispatch(initLoading());

    const url = `/ratings/${action}TeacherRating`;

    try {
      if (action === "update") {
        const responseRatings = await api.put(url, data);

        if (responseRatings.data.success) {
          const response = await api.post(`/studentManagement/createStudentTeacherRestriction`, bodyBlockTeacher);
          const resp = response.data;
          return resp;
        }
      } else {
        const responseRatings = await api.post(url, data);

        if (responseRatings.data.success) {
          const response = await api.post(`studentManagement/createStudentTeacherRestriction`, data);
          const resp = response.data;
          return resp;
        }
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTeacherRestriction", error);

      dispatch(setError(error));
      dispatch(endLoading());
      return true;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLevel = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/studentManagement/listStudentLevelGrade?skip=0&take=999999&id=${id}`);
      const resp = response.data.result.items;
      dispatch(setLevels(resp));
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPlan = (userId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/studentplans/getbyuserid/${userId}`);
      return response.data.result.items;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getPlan", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getStudentPlans = (studentPlanId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`studentplans/${studentPlanId}/studentplanpayments`, {
        params: { studentPlanId: studentPlanId },
      });
      return response.data.result.items;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getPlan", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getActiveLanguagesPlan = (studentPlanId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`studentplans?id=${studentPlanId}`);
      return response.data.result.items;
    } catch (error) {
      console.log("getPlan", error);
      dispatch(setError(error.message));
    }
  };
};

export const postCancelPlan = (id, data, provider) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(
        provider === "stripe" || provider === "stripeBR"
          ? `/studentplans-stripe/${id}/cancel`
          : `/studentplans/${id}/cancel`,
        data,
      );
      const resp = response.data.success;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postCancelPlan", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getClassIdStudent = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(
        `/classSchedules?type=hometop5upcoming&pageNumber=1&pageSize=100&orderByAsc=originalScheduledDateTimeUTC&sort=1&recurrentScheduleId=${id}`,
      );
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getClassIdLast = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(
        `/classSchedules?pageNumber=1&pageSize=1&orderByDesc=originalScheduledDateTimeUTC&sort=1&recurrentScheduleId=${id}`,
      );
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postRating = (dataStudentSendRatingTeacher) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(
        `/ratingCriterias?skip=0&take=100&active=true&target=student`,
        dataStudentSendRatingTeacher,
      );
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postRating", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getClassTimes = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/classSchedules/classTimes`);
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getClassTimes", error);

      dispatch(setError(error.message));
      return false;
    }
  };
};

export const getStudentTeacherRestriction = (studentId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`studentManagement/getStudentTeacherRestriction/${studentId}`);
      return response.data.result.items;
    } catch (error) {
      console.log("getClassTimes", error);

      dispatch(setError(error.message));
      return false;
    }
  };
};

export const getDemoClass = (demoClassId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`demoClasses/${demoClassId}`);
      const resp = response.data.result.items[0];
      dispatch(setDemoClass(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getDemoClass", error);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postCheckClass = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/classSchedules/check`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postCheckClass", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postClass = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/classSchedules`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("🚀 ~ file: student.middleware.js:355 ~ error:", error);
      dispatch(endLoading());
      throw error;
    }
  };
};

export const putCancelClass = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/classSchedules`, data);

      const resp = response.data;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("🚀 ~ putCancelClass ~ error:", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putClassStatus = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/classSchedulesStatus`, data);

      const resp = response.data;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("🚀 ~ putClassStatus ~ error:", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postExtraClassStudent = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentplanpartpayments/execute`, data);
      const resp = response.data;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTeacherRestriction", error);
      dispatch(endLoading());
      dispatch(setError(error));
      return true;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postExtraClassStudentCreate = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentplanpartpayments/create`, data);
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTeacherRestriction", error);
      dispatch(endLoading());
      dispatch(setError(error));
      return true;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPreviousClassesStudent = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/classDetailsPreviousClassesForStudent", body);

      if (response.data.success) {
        dispatch(setAllPreviousClassesStudent(Object.values(response.data.result.items[0])));
      } else {
        dispatch(setAllPreviousClassesStudent([]));
      }
    } catch (error) {
      console.log("getPreviousClassesStudent", error);
    }
  };
};

export const getNextClassesStudent = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/classDetailsNextClassesForStudent", body);

      if (response.data.success) {
        dispatch(setAllNextClassesStudent(response.data.result.items));
      } else {
        dispatch(setAllNextClassesStudent([]));
      }
    } catch (error) {
      console.log("getNextClassesStudent", error);
    }
  };
};

export const getLastSchedulesStudent = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/lastSchedules", body);

      if (response.data.success) {
        dispatch(setLastSchedulesStudent(response.data.result.items));
      } else {
        dispatch(setLastSchedulesStudent([]));
      }
    } catch (error) {
      console.log("getLastSchedulesStudent", error);
    }
  };
};

export const getStudentDashboard = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/studentDashboard", body);

      if (response.data.success) {
        dispatch(setStudentDashboardHeader(response.data.result.items[0]));
      } else {
        dispatch(setStudentDashboardHeader([]));
      }
    } catch (error) {
      console.log("getStudentDashboard", error);
    }
  };
};

export const getLastLanguageOfFormStudent = (body) => {
  return async () => {
    try {
      const response = await api.post("/classSchedulesForm/getLastLanguageOfFormStudent", body);

      if (!response.data.success) return [];
      return response.data.result.items[0];
    } catch (error) {
      console.log("getStudentDashboard", error);
    }
  };
};
